import React, { useEffect, useState } from "react";
import { User } from "~/common/Store/models/User";
import { withUserAndChat } from "~/common/Store/connectUserAndChat";
import CustomerRepContact from "./CustomerRepContact";
import UserPrivileges from "./UserPrivileges";
import AlertsAndNotification from "./AlertsAndNotifications";
import { Notification } from "./Notification";
interface PlatinumProps {
  user: User;
}
const Platinum = ({
  user
}: PlatinumProps) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const isPlatinumUser = user.registered && user.platinum.enabled;
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await fetch("/api:edgecache/getusernotifications");
        if (!response.ok) {
          throw new Error(`Failed to fetch platinum notifications, status: ${response.status}`);
        }
        const data = await response.json<Notification[]>();
        setNotifications(data);
      } catch {
        setNotifications([]);
      }
    };
    if (isPlatinumUser) {
      document.body.classList.add("platinum");
      fetchNotifications();
    }
  }, [isPlatinumUser]);
  const deleteNotificationById = async (messageId: number) => {
    setNotifications(previousNotifications => previousNotifications.filter(notification => notification.id !== messageId));
    try {
      await fetch(`/myaccount/usernotification/${messageId}`, {
        method: "DELETE"
      });
    } catch {
      // do nothing
    }
  };
  const {
    repInfo
  } = user.platinum;
  return <>
      {isPlatinumUser && <div className="container bg-gray-100 pt-6 flex lt:flex-row flex-col lt:space-x-4 space-y-4 md:space-y-6 lt:space-y-0 lt:h-32 h-auto">
          <div className="sm:h-32 lt:h-auto bg-white rounded border border-gray-200 border-solid flex-1 flex flex-col sm:flex-row space-y-2 sm:space-y-0 py-2">
            {!!repInfo?.name?.length && <CustomerRepContact repInfo={repInfo} />}
            <UserPrivileges user={user} showingMessages={notifications.length > 0} />
          </div>
          {notifications.length > 0 && <AlertsAndNotification notifications={notifications} deleteNotificationById={deleteNotificationById} />}
        </div>}
    </>;
};
export default withUserAndChat(Platinum);